// Fluent v9 styles for VirtualContainer
import { makeStyles } from "@fluentui/react-components";
/**
 * Helper to get styles for VirtualContainer
 */ export const useVirtualContainerStyles = makeStyles({
    anchor: {
        // Make sure the anchor isn't 0px by 0px to avoid issues with InView not being called on old versions of Edge
        minHeight: "1px"
    }
});
